import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Abouthouston() {
  return (
    <section className="about_houston p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Driving Chicago's Digital Renaissance through Mobile Innovation
            </h2>
            <p>
              Chicago, the second-largest tech hub in the US, is witnessing a
              mobile app development boom with an 18% annual growth rate.
              TekRevol is at the heart of this revolution, creating innovative
              apps that harness the city's unique potential.
            </p>
            <p>
              Imagine tourists exploring Chicago's rich history with our AR
              walking tour app, bringing landmarks to life. Foodies can discover
              hidden culinary gems through our AI-powered recommendation
              platform. Businesses streamline operations and enhance customer
              engagement with our next-gen mobile solutions. TekRevol’s team
              leverages the latest technologies, including native iOS and
              Android development, cloud integration, and advanced security
              protocols. Partner with us to shape Chicago's dynamic mobile
              future.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Lets Connect
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <StaticImage
              src="../../images/location_new/chicago/driving_chicago.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={779}
              height={763}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Abouthouston;
